import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../_shared/base.service';
import { getUrl } from '../_shared/utils';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class ScheduledEventService extends BaseService {
  userToken: any;
  decodedToken: any;

  constructor(private http: HttpClient, jwtTokenService: JWTTokenService) {
    super(http, jwtTokenService);
  }

  getEvents() {
    return this.http.get<boolean>(getUrl('scheduled-event'), this.buildOptions());
  }

  cancelEvent(timerName: string) {
    return this.http.get<boolean>(getUrl('scheduled-event/cancel/' + timerName), this.buildOptions());
  }

}

